import { render, staticRenderFns } from "./AlertView.vue?vue&type=template&id=7d845fba&"
import script from "./AlertView.vue?vue&type=script&lang=js&"
export * from "./AlertView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d845fba')) {
      api.createRecord('7d845fba', component.options)
    } else {
      api.reload('7d845fba', component.options)
    }
    module.hot.accept("./AlertView.vue?vue&type=template&id=7d845fba&", function () {
      api.rerender('7d845fba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/alerts/AlertView.vue"
export default component.exports